export default {
  companies(state, companies) {
    state.company.list = companies;
  }
};
